import { useQuery } from '@tanstack/react-query';
import { fetchAuthAccessContext } from '@/auth/accessContext';
import { useOrganisationFilter } from '@/features/organisations/providers/organisationHooks';
import { useIsAuthenticated } from '@/shared/hooks/auth';
import { queryKeys } from '@/shared/hooks/queryKeys';
import type { OrganisationRole } from '@flowqa/shared';

export const useCurrentOrgRole = (
  userId: string | null | undefined,
  options?: { enabled?: boolean; organisationId?: string | null },
): { role: OrganisationRole | null; isAdmin: boolean; isLoading: boolean } => {
  const isAuthenticated = useIsAuthenticated();
  const { selectedOrganisationId } = useOrganisationFilter();
  const organisationId = options?.organisationId ?? selectedOrganisationId ?? null;
  const query = useQuery({
    queryKey: queryKeys.currentUserRole(userId, organisationId),
    enabled: isAuthenticated && Boolean(userId && organisationId) && (options?.enabled ?? true),
    queryFn: async () => await fetchAuthAccessContext(organisationId),
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const role: OrganisationRole | null = query.data?.role ?? null;

  return { role, isAdmin: role === 'ADMIN', isLoading: query.isLoading };
};
